module.exports = __webpack_public_path__ + "img/panda_safety_icon.2738b7aa.svg";